module.exports = __webpack_public_path__ + "static/media/brown_belt_icon.d29deb9b.svg";